import React from 'react';
import Layout from '../components/Layout';
import ASNList from '../components/ASNList';


/**
 * Página de listado de órdenes de compra
 * Utiliza el componente Layout para la estructura básica
 * y el componente ASNList para mostrar la lista de órdenes
 */
const NotificationsList = () => {
  return (
    <Layout>
      <div>
        <ASNList />
      </div>
    </Layout>
  );
};

export default NotificationsList;